import type { GameMissionKey } from "../../domain/training/missions";
import { CRISIS_QUESTIONS } from "./crisis";
import { GOLDEN_HOURS_QUESTIONS } from "./goldenHours";
import { ROUND_SIZE } from "./hotkeys";
import { QUEUE_ROUNDS } from "./readQueue";
import { RIGHT_OUTCOME_QUESTIONS } from "./rightOutcome";
import type { QuizQuestion } from "./types";

/** The quiz missions and their questions. */
export const QUIZZES: Partial<Record<GameMissionKey, readonly QuizQuestion[]>> =
  {
    golden_hours: GOLDEN_HOURS_QUESTIONS,
    right_outcome: RIGHT_OUTCOME_QUESTIONS,
    crisis: CRISIS_QUESTIONS,
  };

/** Questions / rounds / prompts per game (the « %{count} » of the mission descriptions). */
export const GAME_SIZES: Record<GameMissionKey, number> = {
  golden_hours: GOLDEN_HOURS_QUESTIONS.length,
  read_queue: QUEUE_ROUNDS.length,
  right_outcome: RIGHT_OUTCOME_QUESTIONS.length,
  hotkeys: ROUND_SIZE,
  crisis: CRISIS_QUESTIONS.length,
};
